/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';
const dateFormat = 'YYYY-MM-DD';

const padZero = (num: any) => num.toString().padStart(2, '0');

const getFormatDate = (date: any) => {
	const myyear = date.getFullYear();
	let mymonth = date.getMonth() + 1;
	let myweekday = date.getDate();
	if (mymonth < 10) mymonth = "0" + mymonth;
	if (myweekday < 10) myweekday = "0" + myweekday;
	return (myyear + "-" + mymonth + "-" + myweekday);
};

/**
 * @function 获取当前年月日
 * @param date 
 * @returns 
 */
export const getFormatDateValue = (date: any) => {
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	let day = date.getDate();
	if (month < 10) month = "0" + month;
	if (day < 10) day = "0" + day;
	return (year + "-" + month + "-" + day);
};

/**
 * @function 计算tag数量
 * @param data 
 * @returns 
 */
export const computeTagShowNum = (data: any) => {
	let actualWidth = 0;
	const maxWidth = data.maxWidth || 196;
	const showTagList: any = [];
	const hidTagList: any = [];
	const tagList = data.tagList || [];
	const tempEl = document.createElement('div');
	tempEl.style.font = data.font || '16px'; // 可以根据需要设置默认字体大小和类型
	tempEl.style.position = 'absolute';
	tempEl.style.visibility = 'hidden';
	tempEl.style.height = 'auto';
	tempEl.style.whiteSpace = 'nowrap';
	tagList.map((item: any) => {
		tempEl.innerText = item;
		document.body.appendChild(tempEl);
		actualWidth = actualWidth + tempEl.offsetWidth + 16;
		if (actualWidth < (maxWidth - 40)) {
			showTagList.push(item);
		} else {
			hidTagList.push(item);
		}
		document.body.removeChild(tempEl);
	});
	return {
		showTagList: showTagList,
		hidTagList: hidTagList
	};
};

/**
 * @function 计算日期
 * @param timestamp 
 * @param type 
 * @returns 
 */
export const getConversionTimeStamp = (timestamp: any, type: any) => {
	// 方法一：利用Date对象进行转换
	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = date.getMonth() + 1; // 月份从0开始计算，需加1
	const day = date.getDate();
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const seconds = date.getSeconds();
	if (type == 1) {
		const dateValue = `${year}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day}`;
		return dateValue;
	} else {
		const dateValue = `${year}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day} ${hours > 9 ? hours : '0' + hours}:${minutes > 9 ? minutes : '0' + minutes}:${seconds > 9 ? seconds : '0' + seconds}`;
		return dateValue;
	}
};

/**
 * @function 获取近多少天
 * @param num 
 */
export const getDatesInRange = (num: any) => {
	const now = new Date();
	const oneDay = 24 * 60 * 60 * 1000;
	const pastDate = new Date(now.getTime() - (num * oneDay));
	const startTime = pastDate.toISOString().split('T')[0];
	const endTime = (new Date(now.getTime() - (1 * oneDay))).toISOString().split('T')[0];
	return {
		startTime: startTime,
		endTime: endTime,
		time: [dayjs(startTime, dateFormat), dayjs(endTime, dateFormat)]
	};
};

/**
 * @function 输出本周的开始时间和结束时间
 * @returns 
 */
export const getThisWeekDates = () => {
	// 获取当前日期
	const today = new Date();
	// 获取今天是星期几（0表示周日，1表示周一，...，6表示周六）
	const todayDayOfWeek = today.getDay();
	// 计算上周周一的日期
	const previousMonday = new Date(today);
	previousMonday.setDate(today.getDate() - todayDayOfWeek + 1);
	// 计算上周周日的日期
	const previousSunday = new Date(previousMonday);
	previousSunday.setDate(previousMonday.getDate() + 6);
	// 格式化日期为字符串
	const startOfWeek = previousMonday.toISOString().split('T')[0];
	const endOfWeek = previousSunday.toISOString().split('T')[0];
	// 返回上周的开始时间和结束时间
	return {
		startTime: startOfWeek,
		endTime: endOfWeek
	};
};

/**
 * @function 上周的开始时间和结束时间
 * @returns 
 */
export const getLastWeekRange = () => {
	// 获取本周开始时间
	const today = new Date();
	const todayDayOfWeek = today.getDay();
	const previousMonday = new Date(today);
	previousMonday.setDate(today.getDate() - todayDayOfWeek + 1);
	const startTime = previousMonday.toISOString().split('T')[0];
	// 获取上周结束时间
	const lastEndTime = new Date(startTime);
	const oneDay = 24 * 60 * 60 * 1000;
	const lastEndStr = new Date(lastEndTime.getTime() - (1 * oneDay));
	const lastEndDate = lastEndStr.toISOString().split('T')[0];
	// 获取上周开始时间
	const lastStartTime = new Date(lastEndDate);
	const lastStartStr = new Date(lastStartTime.getTime() - (6 * oneDay));
	const lastStartDate = lastStartStr.toISOString().split('T')[0];

	return {
		startTime: lastStartDate,
		endTime: lastEndDate
	};
};

/**
 * @function 获取月份的开始结束日期
 * @param type 
 * @returns 
 */
export const getMonthStartAndEnd = (type: any) => {
	if (type == 1) {
		const now = new Date();
		const monthStartDate = new Date(now.getFullYear(), now.getMonth(), 1);
		const numDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
		const monthEndDate = new Date(now.getFullYear(), now.getMonth(), numDay);
		const startTime = getFormatDate(monthStartDate);
		const endTime = getFormatDate(monthEndDate);
		return {
			startTime: startTime,
			endTime: endTime,
			time: [dayjs(startTime, dateFormat), dayjs(endTime, dateFormat)]
		};
	} else if (type == 2) {
		const now = new Date();
		const monthStartDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
		const numDay = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
		const monthEndDate = new Date(now.getFullYear(), now.getMonth() - 1, numDay);
		const startTime = getFormatDate(monthStartDate);
		const endTime = getFormatDate(monthEndDate);
		return {
			startTime: startTime,
			endTime: endTime,
			time: [dayjs(startTime, dateFormat), dayjs(endTime, dateFormat)]
		};
	}
};

/**
 * @param obj 
 * @param char 
 * @returns 
 */
export const hasPropertyWithChar = (obj: any, char: any) => {
	const regex = new RegExp(char);
	return Object.keys(obj).some(prop => regex.test(prop));
}

/**
 * @function 移除千分位分隔符
 * @param numberString 
 * @returns 
 */
export const convertToNumber = (numString: any, zeroFill?: any) => {
	if (numString && typeof numString === 'string') {
		const numString_1 = numString.replace(/w/g, '');
		const thousandSeparated = numString_1.replace(/,/g, '');
		const number = Number(thousandSeparated);
		return Number(number.toFixed(2));
	} else if (numString && typeof numString === 'number') {
		return Number(numString.toFixed(2));
	} else if (zeroFill) {
		return numString;
	} else {
		return numString || 0;
	}
};

/**
 * @function 数字转为千分位
 * @param number 
 * @returns 
 */
export const getFormattedNumber = (number: any) => {
	if (number === 0) {
		return '0.00';
	} else if (number && typeof number === 'number') {
		const val: any = new Intl.NumberFormat('en-US').format(number);
		return val.includes('.') ? val : `${val}.00`
	} else {
		return number || '0.00';
	}
};

/**
 * @function 获取计算值
 * @param value, multiple 
 * @returns 
 */
export const getComputeValue = (value: any, multiple: any) => {
	const value_1 = convertToNumber(`${value}` || 0);
	const totality = value_1 * multiple;
	return totality;
};

/**
 * @function 封装rgbaTo16color功能函数
 * @param color 
 * @returns 功能: 把rgba颜色(或rgb颜色)转成十六进制颜色
 */
export const rgbaTo16color = (color: any) => {
	const val: any = color
		.replace(/rgba?\(/, '')
		.replace(/\)/, '')
		.replace(/[\s+]/g, '')
		.split(',');
	const a: any = parseFloat(val[3] || 1),
		r: any = Math.floor(a * parseInt(val[0]) + (1 - a) * 255),
		g: any = Math.floor(a * parseInt(val[1]) + (1 - a) * 255),
		b: any = Math.floor(a * parseInt(val[2]) + (1 - a) * 255);
	return "#" +
		("0" + r.toString(16)).slice(-2) +
		("0" + g.toString(16)).slice(-2) +
		("0" + b.toString(16)).slice(-2);
};

// export const getHasPermission = (v: any) => {
//     const str = localStorage.getItem('user_info');
//     if (str) {
//         const userInfo = JSON.parse(str);
//         if (v === userInfo.username) return true;
//         else return false;
//     } else {
//         return false;
//     }
// };

/**
 * @function 判断值是否为null/undefined
 * @param v_1 
 * @returns 
 */
export const judgmentValue = (v_1: any) => {
	if (v_1 == null || v_1 == undefined) return false;
	else return true;
};

/**
 * @function 移除百分比符号
 * @param value 
 * @param unit 
 * @returns 
 */
export const removeValueUnit = (value: any, unit: any) => {
	if (value && typeof value === 'string') {
		const val = value.split(unit);
		return Number(val[0]);
	} return value;
};

/**
 * @function 金额转化为分
 * @param value 
 * @returns 
 */
export const getPrecisionValue = (value: any, zero?: any) => {
	let val = value;
	if (val && typeof val === 'string') val = convertToNumber(val);
	if (value) return Math.round(Number(val) * 10000 / 100);
	else if (val == 0) return 0;
	else if (zero) return 0;
	else return null;
};

/**
 * @function 金额为0显示0
 * @param value 
 * @returns 
 */
export const getJudgmentValue = (value: any) => {
	if (value === undefined || value === null) return '-'
	else if (value == 0) return '0.00';
	else if (value && typeof value === 'number') {
		const val = new Intl.NumberFormat('en-US').format(value);
		return val.includes('.') ? val : `${val}.00`
	} else return value;
};

/**
 * @function 自定义校验函数--数值必须大于0
 * @param rule 
 * @param value 
 * @returns 
 */
export const validateQuantityMinNum = (rule: any, value: any) => {
	if (rule.max && value > rule.max) {
		return Promise.reject(new Error(`数值不能大于${rule.max}`));
	} else if (value <= 0) {
		return Promise.reject(new Error(`${rule.msg || '数值'}必须大于0`));
	} else if (!value) {
		return Promise.reject(new Error(`请输入${rule.msg || '数值'}`));
	} else {
		return Promise.resolve();
	}
};

/**
 * @function 自定义校验函数--数值必须小于0
 * @param rule 
 * @param value 
 * @returns 
 */
export const validateQuantityMaxNum = (rule: any, value: any) => {
	if (value >= 0) {
		return Promise.reject(new Error('数值必须小于0'));
	} else if (!value) {
		return Promise.reject(new Error('请输入数值'));
	} else {
		return Promise.resolve();
	}
};

/**
 * @function 数组比较
 * @param arr1 
 * @param arr2 
 * @returns 
 */
export const arraysContainSameElements = (arr1: any, arr2: any) => {
	if (arr1.length !== arr2.length) return false;
	// 创建元素出现次数的映射
	const countMap: any = {};
	// 统计第一个数组元素
	for (const item of arr1) {
		countMap[item] = (countMap[item] || 0) + 1;
	}
	// 检查第二个数组
	for (const item of arr2) {
		if (!countMap[item]) return false;
		countMap[item]--;
	}
	return true;
};

/**
 * @function 判断数组中某值是否相同
 * @param arr
 * @param property
 */
export const areAllValuesSame = (arr: any, property: any) => {
	// 处理空数组情况
	if (arr.length === 0) return true;
	// 获取第一个元素的属性值作为基准
	const baseValue = arr[0][property];
	// 遍历数组检查所有元素
	for (let i = 1; i < arr.length; i++) {
		// 如果有任何一个元素的属性值与基准值不同，返回false
		if (arr[i][property] !== baseValue) return false;
	}
	// 所有元素的属性值都相同，返回true
	return true;
};

/**
 * @function 金额转大写
 * @param amount 金额（支持数字、字符串、带逗号的字符串）
 * @returns 中文大写金额
 */
export const convertToChinese = (amount: any): string => {
	// 1. 类型兼容处理：统一转为字符串，再去除逗号
	let amountStr: string;
	if (amount === null || amount === undefined || amount === '') {
		amountStr = '0';
	} else {
		// 先转成字符串，再去掉所有逗号
		amountStr = String(amount).replace(/,/g, '');
	}
	// 2. 验证是否为有效数字
	const num = Number(amountStr);
	if (isNaN(num)) return "输入不是有效的金额";
	if (num === 0) return "零元整";
	// 定义中文数字和单位
	const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	const integerUnits = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'];
	const decimalUnits = ['角', '分'];
	// 3. 分离整数和小数部分
	const parts = amountStr.split('.');
	// 处理负数（如果需要支持负数，可以在这里处理）
	const isNegative = amountStr.startsWith('-');
	if (isNegative) {
		parts[0] = parts[0].slice(1);
	}
	const integerPart = parts[0] || '0';
	const decimalPart = parts.length > 1 ? parts[1].substring(0, 2) : ''; // 只取两位小数
	// 4. 处理整数部分
	let chineseInteger = '';
	if (parseInt(integerPart, 10) !== 0) {
		for (let i = 0; i < integerPart.length; i++) {
			const digit = parseInt(integerPart[i], 10);
			const position = integerPart.length - i - 1;
			if (digit !== 0) {
				chineseInteger += digits[digit] + integerUnits[position];
			} else {
				// 处理零的情况，避免多个零连续出现
				if (position % 4 !== 0 && chineseInteger[chineseInteger.length - 1] !== '零') {
					chineseInteger += '零';
				}
				// 处理万、亿单位
				if ((position === 4 || position === 8) && chineseInteger[chineseInteger.length - 1] === '零') {
					chineseInteger = chineseInteger.substring(0, chineseInteger.length - 1);
				}
				if (position === 4 || position === 8) {
					chineseInteger += integerUnits[position];
				}
			}
		}
		// 【关键优化】去掉“元”字前面的多余“零”
		if (chineseInteger.endsWith('零')) {
			chineseInteger = chineseInteger.slice(0, -1);
		}
		chineseInteger += '元';
	}
	// 5. 处理小数部分
	let chineseDecimal = '';
	if (decimalPart.length > 0) {
		const jiao = parseInt(decimalPart[0], 10);
		const fen = decimalPart.length > 1 ? parseInt(decimalPart[1], 10) : 0;
		if (jiao !== 0) {
			chineseDecimal += digits[jiao] + decimalUnits[0];
		} else if (fen !== 0) {
			// 角为0但分不为0，需要补零
			chineseDecimal += '零';
		}
		if (fen !== 0) {
			chineseDecimal += digits[fen] + decimalUnits[1];
		}
	}
	// 6. 处理特殊情况
	if (chineseInteger === '' && chineseDecimal === '') {
		return '零元整';
	}
	if (chineseDecimal === '') {
		chineseInteger += '整';
	}
	// 负数处理（如果需要）
	const negativePrefix = isNegative ? '负' : '';
	return negativePrefix + chineseInteger + chineseDecimal;
};

/**
 * @function 使用 Map 或 Object 按唯一属性去重
 * @param arr 
 * @param key 
 * @returns 
 */
export const uniqueByKey = (arr: any, key: any) => {
	const map = new Map();
	return arr.filter((item: any) => {
		// 如果 map 中没有当前 key 的值，则保留并添加到 map
		if (!map.has(item[key])) {
			map.set(item[key], true);
			return true;
		}
		return false;
	});
};

/**
 * @function 获取月份的开始日期
 * @param val 
 * @returns 
 */
export const getMonthStartDay = (val: any) => {
	const now = val ? new Date(val) : new Date();
	const year = now.getFullYear();
	const month = now.getMonth() + 1; // 月份从0开始，需+1
	return `${year}-${padZero(month)}-01`;
};

/**
 * @function 获取月份的结束日期
 * @param val 
 * @returns 
 */
export const getMonthEndDay = (val: any) => {
	const now = val ? new Date(val) : new Date();
	const year = now.getFullYear();
	const month = now.getMonth() + 1;
	const lastDay = new Date(year, month, 0).getDate(); // 获取最后一天的日期数
	return `${year}-${padZero(month)}-${padZero(lastDay)}`;
};

/**
 * 通过日期字符串转换为时间戳
 * @param {string} dateStr - 日期字符串（如 "2026-01-06"）
 * @returns {number} 时间戳（毫秒），无效日期返回 null
 */
export const convertDateStrToTimestamp = (dateStr: any) => {
	const date = new Date(`${dateStr}T00:00:00`);
	if (isNaN(date.getTime())) {
		return null;
	}
	return date.getTime();
};

/**
 * @function 筛选
 * @param input 
 * @param option 
 */
export const filterOption = (input: any, option: any) => {
	return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};


/**
 * 按照指定的 dataIndex 顺序，对表格列进行排序
 * @param {Array} columns 原始列数组
 * @param {Array} order 期望的 dataIndex 顺序数组
 * @returns 排序后的新列数组
 */
export const sortColumnsByOrder = (columns: any, order: any) => {
	// 1. 把列转成 map 方便查找
	const columnMap: any = {};
	const newColumns = JSON.parse(JSON.stringify(columns || {}));
	newColumns.forEach((col: any) => {
		columnMap[col.dataIndex] = col;
	});
	// 2. 按指定顺序生成新数组
	const sortedColumns: any = [];
	order.forEach((key: any) => {
		if (columnMap[key]) {
			sortedColumns.push(columnMap[key]);
		}
	});
	// 3. 把操作列（fixed:right）固定放到最后
	const operateCol = newColumns.find((item: any) => item.fixed === 'right' || item.dataIndex === 'operate');
	if (operateCol && !sortedColumns.includes(operateCol)) sortedColumns.push(operateCol);
	return sortedColumns;
};

/**
 * @function 核心判断函数
 * @param dataList 
 */
export const checkFourFieldsSame = (dataList: any, fields: any) => {
	if (!dataList || dataList.length === 0) return true;
	const base = dataList[0];
	const isAllSame = dataList.every((item: any) => {
		return fields.every((field: any) => item[field] === base[field]);
	});
	return isAllSame;
};